import {
  Button,
  ButtonProps,
  IconButton,
  Tooltip,
} from '@forgeglobal/design-framework';
import { Beneficiary } from '@tcs/client-portal-api/types/Beneficiary';
import { useState } from 'react';
import BaseDialog from '../DialogLayout/BaseDialog';
import { useBeneficiariesErrors } from './forms/BeneficiariesValidators';
import BeneficiaryForm from './forms/BeneficiaryForm';
import useStyles from './style';
import { kebabCase } from 'lodash';

interface BeneficiaryActionButtonProps extends ButtonProps {
  accountNumber: string;
  onSubmit: any;
  beneficiary?: Beneficiary;
  name: string;
  iconButton?: boolean;
  formTitle: string;
  isPrimary: boolean;
}

const TooltipWrapper = ({ tooltip, children }) => {
  if (!tooltip) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={tooltip}>
      <span>{children}</span>
    </Tooltip>
  );
};

const BeneficiaryActionButton = ({
  accountNumber,
  onSubmit,
  beneficiary,
  name,
  iconButton = false,
  startIcon,
  children,
  formTitle,
  isPrimary,
}: BeneficiaryActionButtonProps) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { addBeneficiaryAction } = useBeneficiariesErrors(accountNumber, name);
  const dataTestId = `beneficiary-${kebabCase(formTitle)}-action-button`;

  const handleOnSubmit = (data) => {
    onSubmit(data);
    setOpen(false);
  };

  return (
    <>
      {!iconButton && (
        <TooltipWrapper tooltip={addBeneficiaryAction.tooltip}>
          <Button
            size="small"
            color="secondary"
            className={classes.addButton}
            onClick={() => setOpen(true)}
            disabled={addBeneficiaryAction.disabled}
            data-test-id={dataTestId}
            startIcon={startIcon}>
            {children}
          </Button>
        </TooltipWrapper>
      )}
      {iconButton && (
        <IconButton
          size="small"
          data-test-id={dataTestId}
          onClick={() => setOpen(true)}>
          {children}
        </IconButton>
      )}
      <BaseDialog open={open} onClose={() => setOpen(false)} name="beneficiary">
        <BeneficiaryForm
          accountNumber={accountNumber}
          name={name}
          beneficiary={beneficiary}
          onCancel={() => setOpen(false)}
          onSubmit={handleOnSubmit}
          formTitle={formTitle}
          isPrimary={isPrimary}
        />
      </BaseDialog>
    </>
  );
};

export default BeneficiaryActionButton;
